// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Textarea_textarea__txPdr","textarea_resize":"Textarea_textarea_resize__371eg"};